import { WdprButton } from "components/vista";
import { Context } from "Context";
import { useContext, useEffect } from "react";
import { isCurrentPathPresent } from "utils";
import { Link } from "@wdpr/groot-components";

const buttonVariants = { primary: "primary", inverse: "secondary" };

const StickyCta = ({
	setShowStickyCta,
	showStickyCta,
	variant = buttonVariants.primary,
}) => {
	const {
		headerData: { chrome },
		config: { isTxp },
	} = useContext(Context);

	useEffect(() => {
		setShowStickyCta(
			chrome?.ticketsCta && !isCurrentPathPresent(chrome.excludeTicketCtaPage)
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chrome]);

	if (!showStickyCta) {
		return null;
	}

	const handleRedirect = (e, href) => {
		e.preventDefault();
		window.location.href = href;
	};

	return !isTxp ? (
		<Link
			{...chrome.ticketsCta}
			className="syndicated-navigation__nav__sticky-cta"
		/>
	) : (
		<WdprButton
			variant={buttonVariants[variant]}
			onClick={(e) => handleRedirect(e, chrome.ticketsCta?.href)}
			size="small"
		>
			{chrome.ticketsCta.title}
		</WdprButton>
	);
};

export default StickyCta;
